import {useTranslation} from 'react-i18next'

import routes from 'routes'

import {Container, Text, TextBold, MfaLink} from './WalletMfaActivateInfoBox.styles'

const WalletMfaActivateInfoBox = () => {
  const {t} = useTranslation()

  return (
    <Container>
      <Text>
        <TextBold>{t('wallet.mfaInfo.activateInfo.mfaTextBold')}</TextBold>{' '}
        {t('wallet.mfaInfo.activateInfo.mfaText')}{' '}
        <MfaLink
          to={`${routes.profile.path}/${routes.profile.security.mfa.path}`}
          size='sm'
          text={t('wallet.mfaInfo.activateInfo.mfaActivateText')}
        />
      </Text>

      <Text>
        <TextBold>{t('wallet.mfaInfo.activateInfo.noteTextBold')}</TextBold>{' '}
        {t('wallet.mfaInfo.activateInfo.noteText')}
      </Text>
    </Container>
  )
}

export default WalletMfaActivateInfoBox
